import { ExtendedButtonTheme } from '../../base/tokens'

export const button: ExtendedButtonTheme = {
  base: 'relative px-4 py-2 rounded-lg transition-all duration-300 font-medium flex items-center justify-center',
  variants: {
    primary: `${
      'bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500/20 hover:from-cyan-500/30 hover:to-blue-500/30 hover:border-cyan-400/30 text-cyan-400 hover:text-cyan-300'
    }`,
    secondary: `${
      'w-5 h-5 flex items-center justify-center text-cyan-400/70 hover:text-cyan-400 transition-colors'
    }`
  },
  states: {
    enabled: 'cursor-pointer',
    disabled: 'bg-gray-800/50 border-gray-700 text-gray-600 cursor-not-allowed'
  },
  _variants: {
    icon: {
      base: 'relative group/btn',
      wrapper: 'relative flex items-center justify-center rounded-full border border-cyan-500/20 bg-gray-900/80 overflow-hidden transition-all duration-300 z-20',
      background: 'absolute inset-0 bg-gradient-to-r from-cyan-500/10 to-blue-500/10 scale-[2] opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300',
      gradients: {
        before: 'before:absolute before:inset-0 before:bg-gradient-to-br before:from-cyan-400/5 before:to-transparent',
        after: 'after:absolute after:inset-0 after:bg-gradient-to-br after:from-cyan-500/0 after:to-cyan-500/0 hover:after:from-cyan-500/10 hover:after:to-transparent after:transition-colors after:duration-300'
      }
    },
    checkout: {
      next: {
        enabled: 'bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500/20 hover:from-cyan-500/30 hover:to-blue-500/30 hover:border-cyan-400/30 text-cyan-400 hover:text-cyan-300 px-6',
        disabled: 'bg-gray-800/50 border-gray-700 text-gray-600 cursor-not-allowed px-6'
      },
      back: 'border border-cyan-500/20 text-cyan-400 hover:text-cyan-300 hover:border-cyan-400/30 px-6',
      finish: 'bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-500/20 hover:from-green-500/30 hover:to-emerald-500/30 hover:border-green-400/30 text-green-400 hover:text-green-300 px-6'
    }
  }
} 